// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__RZdfu","title":"ClientInsurance_title__3LDDu","itemText":"ClientInsurance_itemText__xcACX"};